import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as actions from './staff-event.actions';
import * as staffEventQuery from './staff-event.selectors';

@Injectable()
export class StaffEventFacade {
  staffEventSkeletonsLoading$ = this.store.pipe(
    select(staffEventQuery.getStaffEventSkeletonsLoading)
  );
  staffEventSkeletonsLoaded$ = this.store.pipe(
    select(staffEventQuery.getStaffEventSkeletonsLoaded)
  );
  staffEventSkeletons$ = this.store.pipe(select(staffEventQuery.getStaffEventAuditSkeletons));

  staffEventAuditLoading$ = this.store.pipe(select(staffEventQuery.getStaffEventAuditLoading));
  staffEventAuditLoaded$ = this.store.pipe(select(staffEventQuery.getStaffEventAuditLoaded));
  staffEventAudits$ = this.store.pipe(select(staffEventQuery.getStaffEventAudits));

  staffEventBusinessPersonAuditLoading$ = this.store.pipe(
    select(staffEventQuery.getStaffEventBusinessPersonAuditLoading)
  );
  staffEventBusinessPersonAuditLoaded$ = this.store.pipe(
    select(staffEventQuery.getStaffEventBusinessPersonAuditLoaded)
  );
  staffEventBusinessPersonAudits$ = this.store.pipe(
    select(staffEventQuery.getStaffEventBusinessPersonAudits)
  );

  scheduledEventAuditLoading$ = this.store.pipe(
    select(staffEventQuery.getScheduledEventAuditLoading)
  );
  scheduledEventAuditLoaded$ = this.store.pipe(
    select(staffEventQuery.getScheduledEventAuditLoaded)
  );
  scheduledEventAudits$ = this.store.pipe(select(staffEventQuery.getScheduledEventAudits));

  staffEventTypesLoaded$ = this.store.pipe(select(staffEventQuery.getStaffEventTypesLoaded));
  staffEventTypesLoading$ = this.store.pipe(select(staffEventQuery.getStaffEventTypesLoading));
  staffEventTypes$ = this.store.pipe(select(staffEventQuery.getStaffEventTypes));

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadStaffEvents() {
    this.store.dispatch(actions.ResetStaffEvent());
    this.store.dispatch(actions.LoadStaffEventSkeletons());
    this.store.dispatch(actions.LoadStaffEventTypes());
  }

  loadStaffEventAudits(staffEventId: number) {
    this.store.dispatch(actions.LoadStaffEventAudit({ staffEventId }));
  }

  nextStaffEventAuditPage(staffEventId: number) {
    this.store.dispatch(actions.LoadNextPageStaffEventAudit({ staffEventId }));
  }

  loadStaffEventBusinessPersonAudits(staffEventBusinessPersonId: number) {
    this.store.dispatch(actions.LoadStaffEventBusinessPersonAudit({ staffEventBusinessPersonId }));
  }

  nextStaffEventBusinessPersonAuditPage(staffEventBusinessPersonId: number) {
    this.store.dispatch(
      actions.LoadNextPageStaffEventBusinessPersonAudit({ staffEventBusinessPersonId })
    );
  }

  loadScheduledEventAudits(scheduledEventId: number) {
    this.store.dispatch(actions.LoadScheduledEventAudit({ scheduledEventId }));
  }

  nextScheduledEventAuditPage(scheduledEventId: number) {
    this.store.dispatch(actions.LoadNextPageScheduledEventAudit({ scheduledEventId }));
  }
}
